import css from 'styled-jsx/css';

const styles = css`:root {
  /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */
  --black: #000000;
  --dark-gray: #b3b3b3;
  --error: red;
  --success: #248647;
  --green: green;
  --lightgreen: lightgreen;
  --gray-1: #787778;
  --gray-2: #bbbbbb;
  --gray-2-5: #d8d8d8;
  --gray-3: #eeeeee;
  --gray-4: #f8f8f8;
  --gray-5: #fafafa;
  --gray-6: #ebebeb;
  --gray-footer: #4f4f4f;
  --gray-footer-text: #757575;
  --gray-black: #111111;
  --heading-gray: #505050;
  --border-gray: #c8c8c8;
  --gray-background: rgba(0, 0, 0, 0.2);
  --warning: #daaa00;

  --mmr-yellow: #f8e71c;
  --mmr-red: #b41f00;
  --module-gray: #f7f7f7;
  --module-white: #ffffff;
  --primary-bg: #eeeeee;
  --clear: transparent;

  --risk-high: #e37a00;
  --risk-low: #7c993f;
  --risk-med: #ffcc00;
  --text-fg: #3b3b3b;
  --text-header: #4c5a6a;
  --tooltip-header: #4c5a69;
  --warm-grey: #898989;
  --white: #ffffff;
  --border-line: #b8b8b8;
  --orange-button: #e17a17;

  --text-dark: #3b3b3b;
  --text-med: #4f4f4f;
  --text-light: #898989;
  --text-xlight: #c4c4c4;
  --text-disabled: #b1b1b1;

  --subtle-blue-gray: #f7f9fa;
  --trp-dark-blue: #004b71;
  --trp-light-blue: #eef7fa;
  --trp-bright-blue: #05c3de;
  --ice-blue: #24c0d8;
  --row-blue: #06c3df;
  --trp-dark-blue: #0063ad;
  --dark-blue: #054c70;
  --dark-blue-2: #043954;
  --navy-blue: #0a4c71;
  --trp-nav-dark-blue: #061937;
  --trp-bottom-footer-blue: #0c2a4d;
  --trp-link-blue: #80c8ff;
  --trp-tag-blue: #00cfec;

  --navy-gradient: linear-gradient(115deg, #054c70, #086ea1);

  /* NASU Specifc Colors */
  /* TODO [2020-08-05]: change these colors to EDDS approved colors if they are not already */
  --BYOP-header-grey: #f0f3f5;
  --BYOP-header-contents-grey: #f7f9fa;

  /* 2020 colors */
  --primary-blue: #086ea1;
  --brand-interactive-blue: #006894;
  --grey-text: #475359;
  --gray-back: #f1f1f1;
  --gray-morningstar: #6b7880;
  --gray-non-rated-star: #b4babf;
  --gray-risk-reward-bar: #e9edf0;
  --green-risk-reward-thumb: #7d9845;
  --yellow-risk-reward-thumb: #ffcf3d;
  --orange-risk-reward-thumb: #e17a17;
  --gray-header-bottom-border: #879199;
  --gray-disabled-button: #e1e5e8;
  --border-white: #d3d7da;
  --link-blue: #006894;
  --qv-header-bottom-border: #d7dbde;
  --required-error-msg: #cc1f1f;
  --no-funds-error-msg: #dd3636;

  /* Beacon colors */
  --beacon-primary: #8b57d9;
  --input-field-title: #3b4b59;
  --background-blue: #253746;
}
:root {
  --page-max-width: 1230px;
  --page-padding: 32px;
  --module-gutter: 24px;
  --half-gutter: calc(var(--module-gutter) / 2);
  --quarter-gutter: calc(var(--half-gutter) / 2);
  --module-padding: 24px;
  --mobile-padding: 4px;
  --min-content: min-content;

  /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */
  --element-spacing-1: 8px;
  --element-spacing-2: calc(var(--element-spacing-1) * 2);
  --element-spacing-3: calc(var(--element-spacing-1) * 3);
  --element-spacing-4: calc(var(--element-spacing-1) * 4);
  --element-spacing-5: calc(var(--element-spacing-1) * 5);
  --element-spacing-6: calc(var(--element-spacing-1) * 6);
  --element-spacing-7: calc(var(--element-spacing-1) * 7);
  --element-spacing-8: calc(var(--element-spacing-1) * 8);
  --element-spacing-9: calc(var(--element-spacing-1) * 9);
  --element-spacing-10: calc(var(--element-spacing-1) * 10);
  --element-spacing-11: calc(var(--element-spacing-1) * 11);

  --border-thin-width: 1px;
  --border-width: 2px;
  --border-radius: 5px;

  /* New II Design Pattern - Introduced 11-12-2019 */
  --page-focus-width: 544px;
  --help-focus-width: 328px;
}
:root {
  --xxxsmall-font: 10px;
  --xxsmall-font: 12px;
  --xsmall-font: 14px;
  --small-font: 16px;
  --med-font: 18px;
  --large-font: 20px;
  --xlarge-font: 24px;
  --xxlarge-font: 36px;
  --xxxlarge-font: 48px;
  --title-font: 18px;
  --label-sup-font: 100%;

  --h1-font: 32px;
  --h2-font: 20px;
  --p1: 16px;
  --p2: 14px;
  --caption-size: 12px;

  --h1-font-mobile: 24px;
  --h2-font-mobile: 18px;
  --p1-mobile: 16px;
  --p2-mobile: 14px;
  --caption-size-mobile: 12px;

  --roboto-flex-font: 'Roboto Flex', sans-serif;
  --sans-novus: 'Roboto Flex Novus';
  --condensed-font: 'Roboto Flex Condensed', 'Roboto Flex', sans-serif;
  --condensed-bold: 'Roboto Flex Condensed Bold', 'Roboto Flex Condensed',
    sans-serif;
  --serif-font: 'IBM Plex Serif', serif;
  --mono-font: 'Roboto Flex', sans-serif;

  --roboto-reg: 'Roboto Flex Reg', sans-serif;
  --roboto-italic: 'Roboto Flex Italic', sans-serif;
  --roboto-bold: 'Roboto Flex Bold', sans-serif;
  --roboto-light: 'Roboto Flex', sans-serif;
  --roboto-black: 'Roboto Flex Black', sans-serif;

  --rocky-reg: 'Rocky Reg', sans-serif;
  --rocky-light: 'Rocky Light', sans-serif;

  --regular-weight: 400;
  --bold-weight: 700;
  --light-weight: 100;
  --normal-weight: normal;

  --checkbox-height: 25px;
  --checkbox-width: 25px;
}
:root {
  --trp-logo-width: var(--element-spacing-9);
  --trp-logo-height: var(--element-spacing-9);
}
.navbar-brand {
  margin-left: calc(8px * 4);
  margin-top: calc(8px * 3);
}
.trp-trusty-img {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='72' height='72' viewBox='0 0 72 72' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url%28%23clip0_1136_3579%29'%3E%3Crect width='72' height='72' fill='white'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 0V72H18.9547C19.6146 64.85 20.4143 61.99 24.1933 54.57C28.4921 46.13 29.8117 39.71 29.8117 31.39C29.8117 31.2927 29.8125 31.1864 29.8133 31.0731C29.8198 30.1968 29.8294 28.905 29.5018 28.17C27.8023 28.34 25.373 27.59 23.9334 25.86C22.7137 24.38 21.8839 22.49 21.8839 21.3C21.8839 21.04 21.9139 20.85 22.0739 20.69C23.6634 20.25 26.7826 20.96 28.902 21.95C29.7717 20.53 30.5315 19.61 32.421 18.57C30.7015 14.92 27.5823 12.48 22.8836 12.48C17.4552 12.48 13.8961 15.53 12.7365 18.48C12.3866 19.38 12.8664 19.57 13.4463 18.99C15.7856 16.61 18.2649 15.43 21.504 15.43C25.4829 15.43 27.8223 17.93 27.8223 18.99C27.8223 19.34 27.5623 19.34 27.2124 19.21L27.1642 19.1942C25.9042 18.7805 24.7757 18.41 22.6237 18.41C16.6254 18.41 13.8661 24.03 13.8661 28.81C13.8661 31.44 14.7959 33.37 16.6254 33.37C18.035 33.37 18.8448 32.47 19.5446 31.03C19.7645 30.58 20.1244 30.58 20.4143 31.06C20.8042 31.7 20.8942 32.79 20.8942 33.63C20.8942 37.42 18.105 39.41 14.8959 39.41C8.89753 39.41 5.23854 34.08 5.23854 27.15C5.23854 17.78 11.1469 7.92 23.1436 7.92C31.7812 7.92 36.2699 12.53 38.6593 17.1H39.9289C41.6584 12.99 44.7776 10.55 49.4263 10.55C55.6245 10.55 58.1838 15.37 58.1838 21.11C58.1838 22.6809 58.0188 24.1895 57.8605 25.6374C57.7144 26.973 57.574 28.2568 57.574 29.49C57.574 31.38 58.3738 33.5 60.5232 33.5C61.9028 33.5 63.0625 32.6 63.6323 30.45C63.7923 29.87 64.1422 29.78 64.632 30.39C64.952 30.78 65.4018 31.71 65.4018 32.8C65.4018 35.82 63.4424 39 59.5235 39.03C56.1844 39.06 54.165 37.23 53.7451 34.92C53.6851 34.53 54.035 34.34 54.2549 34.66C55.4746 36.27 57.0442 37.13 59.2635 37.13C60.5132 37.13 61.7628 36.58 62.1827 35.65C62.3127 35.36 62.2127 35.2 61.9928 35.3C61.223 35.65 60.5532 35.78 59.8134 35.78C54.6748 35.78 54.035 30.55 53.6851 25.25C53.2052 26.63 52.2755 27.82 49.8662 28.04C50.0861 27.69 50.256 27.11 50.256 26.69C50.256 26.27 50.0361 25.98 49.5162 25.98C48.7465 25.98 48.0766 26.56 48.0766 27.49C48.0766 28.4238 48.7643 29.4058 49.4753 30.4212C50.0588 31.2544 50.658 32.1101 50.9059 32.98C51.0658 33.56 51.0658 34.07 51.0658 34.71C51.0658 35.83 50.9359 36.93 50.7759 37.47C50.6459 37.89 50.356 38.02 49.5262 38.02C48.9464 38.02 48.7565 37.83 48.6265 37.35C48.5665 37.09 48.4665 36.77 48.2766 36.77C48.067 36.77 47.9936 37.0062 47.9006 37.3054L47.8867 37.35C47.6968 38.02 47.1169 38.15 45.7373 38.15C45.1996 38.15 44.8471 38.1229 44.6162 38.1051H44.6161H44.6161L44.616 38.1051C44.5035 38.0964 44.4199 38.09 44.3577 38.09C44.0078 38.09 43.8778 38.22 43.8778 38.41C43.8778 38.67 43.9078 38.92 43.9778 39.15C44.0378 39.34 44.1677 39.41 44.5576 39.34C45.8373 39.15 46.967 39.12 47.8267 39.12C50.1661 39.12 50.296 39.34 50.1061 40.15C49.9461 40.86 49.6862 41.79 49.3063 42.62C49.0464 43.17 48.8564 43.23 48.4765 43.26C47.7068 43.32 46.677 43.36 45.9072 43.32C44.5099 43.2542 43.2844 42.8113 42.119 42.3902C40.9831 41.9798 39.9043 41.59 38.7792 41.59C38.1699 41.59 37.6128 41.6732 37.0419 41.7585C36.4421 41.8481 35.8271 41.94 35.1202 41.94C33.7406 41.94 32.7609 41.65 31.8212 40.98C30.4615 46.18 29.9617 52.53 29.9617 55.45C29.9617 57.47 30.5415 59.66 31.5712 60.49C31.9211 60.78 32.241 60.78 32.501 60.3C35.0084 55.6355 37.7216 54.0276 40.2896 52.5059C42.6874 51.0849 44.9585 49.7391 46.817 46.05C47.0069 45.7 47.3968 45.76 47.4568 46.18C48.0966 49.97 47.6768 54.56 46.847 58.96C46.747 59.47 47.1069 59.67 47.4568 59.22C48.5165 57.87 49.8961 55.43 50.406 53.47C50.536 52.99 50.9159 52.96 51.1158 53.44C52.3655 56.49 53.7751 62.27 54.195 66.44C54.2249 66.89 54.6448 66.92 54.8048 66.5C55.7045 64 56.2844 59.85 55.6046 56.8C55.5446 56.45 55.7345 56.25 56.1144 56.45C61.6929 59.16 67.1214 64.14 72 71.98V0H0ZM23.1341 65.1C22.1641 67.2 21.4341 69.52 21.2541 72H24.3941C23.9041 69.53 23.8441 67.14 23.8441 65.1C23.8441 64.43 23.5241 64.23 23.1341 65.1ZM45.7273 35.31C44.9875 35.37 44.6676 35.08 44.6676 34.12H44.6776C44.6776 33.8 44.9375 33.38 45.4174 33.38C45.6454 33.38 45.912 33.4104 46.2316 33.4469C46.7107 33.5017 47.3092 33.57 48.0766 33.57C48.3261 33.57 48.5664 33.5332 48.8162 33.4948L48.8164 33.4948L48.8165 33.4948C49.0872 33.4533 49.3691 33.41 49.6862 33.41C50.0361 33.41 50.1961 33.64 50.1961 34.15C50.1961 34.86 50.1261 35.28 49.6462 35.31C48.9064 35.34 48.7465 35.47 48.5865 36.08C48.4865 36.37 48.1666 36.43 48.0067 36.11C47.6168 35.31 46.947 35.21 45.7273 35.31ZM38.4393 26C37.8895 25.2 36.3199 24.2 34.7503 24.23C33.3107 24.2 32.411 25.16 32.411 25.93C32.411 26.12 32.541 26.25 32.7309 26.12C33.0208 25.96 33.2108 25.9 33.4407 25.9C33.7006 26.73 34.4404 27.79 35.88 27.79C36.9697 27.79 37.8395 27.28 37.6795 26.12C37.9395 26.12 38.0994 26.15 38.3194 26.22C38.4493 26.25 38.5093 26.09 38.4493 26H38.4393ZM49.1963 18.45C51.3457 18.45 52.7254 20.18 53.3652 22.27C51.6257 21.98 50.6659 21.98 49.5762 23.23C48.9664 21.47 47.5568 20.09 46.3371 19.51C46.727 19.06 47.5868 18.45 49.1963 18.45Z' fill='%2300CFEC'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_1136_3579'%3E%3Crect width='72' height='72' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
  display: block;
  height: calc(8px * 9);
  width: calc(8px * 9);
}
.logo-wrapper {
  display: flex;
}
.navbar-default {
  background-color: #061937;
}
.navbar {
  display: flex;
  justify-content: space-between;
  border: none;
  border-radius: 0;
  border-width: 0 0 1px;
}
.logout-button {
  margin-right: calc(8px * 2);
  margin-top: calc(8px * 2);
  list-style: none outside none;
}
`;

export default styles;